import { getLabel } from "../../../../../../hooks/use-labels";

const OrderHistoryBox = ({ timeline, state, footer }) => {
  const steps = timeline || [];

  if (!steps.length && !footer) return null;

  return (
    <section className="ord-panel">
      {steps.length > 0 && (
        <h2 className="ord-panel-title">{getLabel("orderTrackLabel")}</h2>
      )}

      <ol className={`ord-track${state ? ` is-${state}` : ""}`}>
        {steps.map((step, index) => (
          <li
            className={`ord-track-item${step.completed ? " is-done" : ""}${
              step.terminal ? " is-terminal" : ""
            }`}
            key={`${step.step}-${index}`}
          >
            <span className="ord-track-marker">
              <span className="ord-track-glow" aria-hidden="true" />
              <span className="ord-track-dot" aria-hidden="true" />
            </span>

            <span className="ord-track-body">
              <span className="ord-track-text">
                <span className="ord-track-title">{step.title}</span>

                {step.subtitle && (
                  <span className="ord-track-sub">{step.subtitle}</span>
                )}
              </span>

              <span className="ord-track-when">
                <span>{step.date}</span>
                <span>{step.time}</span>
              </span>
            </span>
          </li>
        ))}
      </ol>

      {footer && <div className="ord-track-actions">{footer}</div>}
    </section>
  );
};

export default OrderHistoryBox;
